<div [ngClass]="getClassList()" (click)="handleButtonClick()" tabindex="0" (keydown.enter)="handleButtonClick()" (keydown.space)="handleButtonClick()" #buttonElement>
  <div class="text-frame">
    <div class="body-bold">{{ label }}</div>
  </div>
</div>
